import { h, Host } from '@stencil/core';
export class AibaCompareSlider {
  constructor() {
    this.data = undefined;
    this.handlers = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.options = undefined;
    this.image1 = undefined;
    this.image2 = undefined;
    this.handleImage = undefined;
    this.spanText = undefined;
    this.showText = true;
    this.attr = {};
    this.imagesNotPresent = undefined;
    this.imagesNotPresentRenderData = undefined;
  }
  async componentWillLoad() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    const { options, image1, image2, init_image1 = image1, init_image2 = image2, handleImage, styles, classes, spanText, imagesNotPresentRenderData, attr = {} } = this.data;
    this.options = options;
    this.image1 = init_image1;
    this.image2 = init_image2;
    this.handleImage = handleImage;
    this.styles = styles;
    this.classes = classes;
    this.spanText = spanText;
    this.attr = attr;
    this.imagesNotPresentRenderData = imagesNotPresentRenderData;
    await this.insertScripToDOM();
  }
  async insertScripToDOM() {
    const scriptPresent = document.querySelector('#img-comparision-slider-script');
    if (!scriptPresent) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/img-comparison-slider@8/dist/index.js';
      script.id = 'img-comparision-slider-script';
      script.async = true;
      typeof window !== 'undefined' ? document.body.appendChild(script) : null;
      await document.querySelector('#img-comparision-slider-script');
    }
  }
  async componentDidLoad() {
    var _a, _b;
    const { image1, image2 } = this.data;
    this.image1 = image1;
    this.image2 = image2;
    this.parentRef &&
      ((_a = this.parentRef) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', () => {
        console.log('@AIBA[AibaCompareSlider]: Slider drag started');
        this.showText = false;
      }));
    this.parentRef &&
      ((_b = this.parentRef) === null || _b === void 0 ? void 0 : _b.addEventListener('touchstart', () => {
        console.log('@AIBA[AibaCompareSlider]: Slider drag started ');
        this.showText = false;
      }));
    const handlers = this.handlers;
    this.image2Ref &&
      this.image2Ref.addEventListener('load', async () => {
        handlers && handlers.handleCompareSliderImagesLoad && (await handlers.handleCompareSliderImagesLoad());
      });
    this.image2Ref &&
      this.image2Ref.addEventListener('error', async () => {
        this.imagesNotPresent = true;
        handlers && handlers.handleCompareSliderImagesError && (await handlers.handleCompareSliderImagesError());
      });
    this.image1Ref &&
      this.image1Ref.addEventListener('error', async () => {
        this.imagesNotPresent = true;
        handlers && handlers.handleCompareSliderImagesError && (await handlers.handleCompareSliderImagesError());
      });
    this.handlers && this.handlers.handleCompareSliderDidLoad && (await this.handlers.handleCompareSliderDidLoad());
  }
  async componentDidRender() {
    this.handlers && this.handlers.handleCompareSliderDidRender && (await this.handlers.handleCompareSliderDidRender());
  }
  render() {
    var _a;
    return (h(Host, { class: this.imagesNotPresent ? 'images-not-present-host-container' : 'images-present-host-container' }, this.styles && h("style", null, this.styles), h("div", { class: `compare-slider-container ${this.classes ? this.classes : ''} ${this.imagesNotPresent ? 'images-not-present-container' : ''}` }, !this.imagesNotPresent ? (h("div", { class: "compare-slider-wrapper" }, h("img-comparison-slider", Object.assign({}, this.options, { ref: el => (this.parentRef = el) }), h("img", Object.assign({ slot: "first", src: this.image1 }, this.attr, { ref: el => (this.image1Ref = el) })), h("img", Object.assign({ slot: "second", src: this.image2 }, this.attr, { ref: el => (this.image2Ref = el) })), this.spanText && this.spanText.length ? (h("div", { slot: "handle" }, h("img", { class: "handle", src: this.handleImage }), this.showText && (h("span", { class: "slidable-span-text", id: "slidable-span-text", innerHTML: this.spanText })))) : (h("img", { slot: "handle", class: "handle", src: this.handleImage }))))) : (h("div", { class: "image-not-present-wrapper" }, this.imagesNotPresentRenderData &&
      ((_a = this.imagesNotPresentRenderData) === null || _a === void 0 ? void 0 : _a.elements.map(item => {
        if (item && item['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, item['data']));
        }
        if (item && item['name'] === 'img') {
          return h("img", Object.assign({}, item['data']));
        }
      })))))));
  }
  static get is() { return "aiba-compare-slider"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-compare-slider.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-compare-slider.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "styles": {},
      "classes": {},
      "options": {},
      "image1": {},
      "image2": {},
      "handleImage": {},
      "spanText": {},
      "showText": {},
      "attr": {},
      "imagesNotPresent": {},
      "imagesNotPresentRenderData": {}
    };
  }
}
//# sourceMappingURL=aiba-compare-slider.js.map
